/**
 * Yayinlanmis kural setini indirir.
 *
 * Kural seti public settings payload'ina girmez (sisirmesin); orada yalnizca
 * `eventRulesVersion` tasinir. Surum localStorage'daki kopyayla ayniysa aga cikilmaz.
 * Endpoint CloudFront'ta 5 dk cache'lenir.
 */
import log2 from "../../../js/log2-lite";
import { buildUrl } from "../../utils";

const log = log2("TRACKER_RULES");

const CACHE_PREFIX = "supsis-wa-rules:";

function cacheKey(siteId) {
    return CACHE_PREFIX + String(siteId);
}

function readCache(siteId) {
    try {
        const raw = window.localStorage.getItem(cacheKey(siteId));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.version !== "number" || !parsed.payload) return null;
        return parsed;
    } catch (e) {
        return null;
    }
}

function writeCache(siteId, version, payload) {
    try {
        window.localStorage.setItem(cacheKey(siteId), JSON.stringify({ version: version, payload: payload }));
    } catch (e) {
        /* private mode / kota: bellekteki kural seti yeterli */
    }
}

/**
 * @param {String} siteId
 * @param {Number} version settings'ten gelen eventRulesVersion
 * @returns {Promise<Object|null>} { version, rules, paths }
 */
export function loadRuleset(siteId, version) {
    const currentVersion = parseInt(version, 10) || 0;
    // Hic kural yayinlanmadiysa istek atilmaz
    if (currentVersion <= 0) return Promise.resolve(null);

    const cached = readCache(siteId);
    if (cached && cached.version === currentVersion) {
        log.debug("ruleset from cache", { version: currentVersion });
        return Promise.resolve(cached.payload);
    }

    // siteId query'de tasinir: custom header eklemek CORS preflight'i tetikler
    const url = buildUrl("public/web-analytics/rules") + "?siteId=" + encodeURIComponent(siteId);

    return fetch(url)
        .then(function (response) {
            if (!response || response.status !== 200) return null;
            return response.json();
        })
        .then(function (payload) {
            if (!payload || !Array.isArray(payload.rules)) return cached ? cached.payload : null;
            writeCache(siteId, currentVersion, payload);
            log.debug("ruleset fetched", { version: currentVersion, count: payload.rules.length });
            return payload;
        })
        .catch(function (e) {
            log.debug("ruleset fetch failed", e);
            return cached ? cached.payload : null;
        });
}

export default loadRuleset;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/rules/loader.js
// module id = null
// module chunks = 